exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "builderall-icon[data-v-0c7e05b6]{--builderall-icon-size:20px;margin:0 5px}.box-title[data-v-0c7e05b6]{color:#0080fc;text-align:center;font-size:20px}.box-associate-tokens[data-v-0c7e05b6]{margin:1em 2em}.box-associate-tokens .header-link[data-v-0c7e05b6]{color:#691fa5;font-size:13px;width:100%}.box-associate-tokens .container-link[data-v-0c7e05b6]{width:33%}.box-associate-tokens .container-link span[data-v-0c7e05b6]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:13px;margin:0 10px 0 0}p[data-v-0c7e05b6]{font-size:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c7e05b6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/franchise_v5/affiliate_dashboard/associate-tokens/index.vue
// module id = cqEc
// module chunks = 0